import { getHandlers } from '../utils.js'

const GEO_FIELDS = ['US', 'Global', 'Other? Please List']

const handleGeoChange = (onChange, _, all) => {
  const values = []
  const geoFields = all.filter(
    (pair) => pair[1] === 'Global' || pair[1] === 'US' || pair[1].includes('Other?')
  )

  geoFields.forEach((pair) => {
    if (!pair[1].includes('Other?')) {
      values.push(pair[1])
    } else {
      values.push(...pair[0].split(',').map((val) => val.trim()))
    }
  })

  onChange({}, 'geos', values)
}

export default getHandlers(GEO_FIELDS, handleGeoChange)
